import { Matches } from '@/context/LivescoreContext';

export type MatchStatus =
  | 'NIE ZACZĘTY'
  | 'ROZPOCZĘTY'
  | 'LIVE'
  | 'PRZEŁOŻONY'
  | 'ZAWIESZONY'
  | 'OPÓŹNIONY'
  | 'PRZERWANY'
  | 'ANULOWANY'
  | 'ZAKOŃCZONE'
  | 'PORZUCONY';

export type DetailedMatchStatus =
  | 'NIE ZACZĘTY'
  | 'ROZPOCZĘTY'
  | '1. POŁ'
  | '2. POŁ'
  | 'DOGRYWKA'
  | '1. POŁ DOGRYWKI'
  | '2. POŁ DOGRYWKI'
  | 'OCZEKIWANIE NA RZUTY KARNE'
  | 'RZUTY KARNE'
  | 'OCZEKIWANIE NA DOGRYWKĘ'
  | 'PRZERWANY'
  | 'PORZUCONY'
  | 'PRZEŁOŻONY'
  | 'OPÓŹNIONY'
  | 'ANULOWANY'
  | 'PRZERWA'
  | 'PRZERWA W DOGRYWCE'
  | 'ZAKOŃCZONE'
  | 'ZAKOŃCZONE DOGRYWKĄ'
  | 'ZAKOŃCZONE RZUTAMI KARNYMI';

export const blackStatuses: (MatchStatus | DetailedMatchStatus)[] = ['NIE ZACZĘTY'];

export const redStatuses: (MatchStatus | DetailedMatchStatus)[] = [
  'PRZERWANY',
  'PORZUCONY',
  'PRZEŁOŻONY',
  'OPÓŹNIONY',
  'ANULOWANY',
  'ZAWIESZONY', // Dodano MatchStatus
];

export const greenStatuses: (MatchStatus | DetailedMatchStatus)[] = [
  'ROZPOCZĘTY',
  'RZUTY KARNE',
  'PRZERWA',
  'PRZERWA W DOGRYWCE',
  'LIVE', // Dodano MatchStatus
  '1. POŁ',
  '2. POŁ',
];

export const grayStatuses: (MatchStatus | DetailedMatchStatus)[] = [
  'ZAKOŃCZONE RZUTAMI KARNYMI',
  'ZAKOŃCZONE DOGRYWKĄ',
  'DOGRYWKA',
  '1. POŁ DOGRYWKI',
  '2. POŁ DOGRYWKI',
  'OCZEKIWANIE NA RZUTY KARNE',
  'OCZEKIWANIE NA DOGRYWKĘ',
  'ZAKOŃCZONE',
];

function translateMatchStatus(status: string): MatchStatus | undefined {
  switch (status) {
    case 'not_started':
      return 'NIE ZACZĘTY';
    case 'started':
      return 'ROZPOCZĘTY';
    case 'live':
      return 'LIVE';
    case 'postponed':
      return 'PRZEŁOŻONY';
    case 'suspended':
      return 'ZAWIESZONY';
    case 'delayed':
      return 'OPÓŹNIONY';
    case 'interrupted':
      return 'PRZERWANY';
    case 'cancelled':
      return 'ANULOWANY';
    case 'ended':
    case 'clossed':
      return 'ZAKOŃCZONE';
    case 'abandoned':
      return 'PORZUCONY';
    default:
      return undefined;
  }
}

function translateDetailedMatchStatus(status: string): DetailedMatchStatus | undefined {
  switch (status) {
    case 'not_started':
      return 'NIE ZACZĘTY';
    case 'started':
      return 'ROZPOCZĘTY';
    case '1st_half':
      return '1. POŁ';
    case '2nd_half':
      return '2. POŁ';
    case 'overtime':
      return 'DOGRYWKA';
    case '1st_extra':
      return '1. POŁ DOGRYWKI';
    case '2nd_extra':
      return '2. POŁ DOGRYWKI';
    case 'awaiting_penalties':
      return 'OCZEKIWANIE NA RZUTY KARNE';
    case 'penalties':
      return 'RZUTY KARNE';
    case 'awaiting_extra_time':
      return 'OCZEKIWANIE NA DOGRYWKĘ';
    case 'interrupted':
      return 'PRZERWANY';
    case 'abandoned':
      return 'PORZUCONY';
    case 'postponed':
      return 'PRZEŁOŻONY';
    case 'start_delayed':
      return 'OPÓŹNIONY';
    case 'cancelled':
      return 'ANULOWANY';
    case 'halftime':
      return 'PRZERWA';
    case 'extra_time_halftime':
      return 'PRZERWA W DOGRYWCE';
    case 'ended':
      return 'ZAKOŃCZONE';
    case 'aet':
      return 'ZAKOŃCZONE DOGRYWKĄ';
    case 'ap':
      return 'ZAKOŃCZONE RZUTAMI KARNYMI';
    default:
      return undefined;
  }
}

/**
 * Figure out match status in polish based on match_status (more detailed) or status (less detailed)
 * @param status
 * @returns match status in polish based on match status
 */
export function getMatchStatus(status: Matches[string]['matches'][number]['sport_event_status']) {
  const matchStatus = translateDetailedMatchStatus(status.match_status ?? '');

  if (matchStatus) {
    return matchStatus;
  }

  return translateMatchStatus(status.status);
}
